<script>
import TextInput from "@/components/TextInput";
import ModifyButtons from "@/components/ModifyButtons";
import ErrorMessage from "@/components/ErrorMessage";
import TownSelection from "@/components/TownSelection";
import bus from "@/bus";
import { useTownSelectionStore } from "../../stores/townSelection";
import { useResourcesStore } from "../../stores/resources";

export default {
  setup() {
    const townSelectionStore = useTownSelectionStore();
    const resourcesStore = useResourcesStore();
    return {
      townSelectionStore,
      resourcesStore,
    }
  },
  components: {
    TextInput,
    TownSelection,
    ModifyButtons,
    ErrorMessage,
  },
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      communeDropdownExpanded: false,
      lastname: this.params.lastname,
      firstname: this.params.firstname,
      phone: this.params.phone,
      email: this.params.email,
      id: this.params.id,
      role: "User",
      errors: [],
    };
  },
  methods: {
    closeMessage(id) {
      Object.keys(this.errors).forEach((key) => {
        if (id === this.errors[key].id) {
          this.errors.splice(key, 1);
        }
      });
    },
    async modify() {
      const { firstname, lastname, email, phone, role } = this;
      const { id } = this;
      const towns = this.townSelectionStore.ids;

      const error = await this.resourcesStore.updateAccount({
        id,
        data: {
          firstname:
            firstname !== this.params.firstname ? firstname : undefined,
          lastname: lastname !== this.params.lastname ? lastname : undefined,
          email: email !== this.params.email ? email : undefined,
          phone: phone !== this.params.phone ? phone : undefined,
          role,
          towns,
        },
        type: "user",
      })
      if (error) {
        this.errors.push({
          id: Date.now(),
          message: error.data.message,
        });
      } else {
        this.close();
      }
    },
    async deleteAccount() {
      const error = await this.resourcesStore.deleteAccount({
        id: this.id,
        type: "user",
      });
      if (error) {
        this.errors.push({
          id: Date.now(),
          message: error.data.message,
        });
      } else {
        this.close();
      }
    },
    close() {
      bus.emit("closeModal");
    },
  },
};
</script>

<template>
  <div class="p-8 z-50 bg-white shadow-xl rounded sm:min-w-lg sm:max-w-2xl">
    <header class="text-gray-700 text-xl font-bold pb-5">
      <span>{{ $t("views.modals.modify_user.edit") }}</span>
    </header>

    <div v-for="msg in errors" :key="msg.id">
      <ErrorMessage :value="msg" @input="closeMessage" />
    </div>

    <TextInput id="nom" v-model="lastname" data-cy="lastname" :label="$t('views.modals.modify_user.last_name')"
      type="text" class="mb-4" />
    <TextInput id="prenom" v-model="firstname" data-cy="firstname" :label="$t('views.modals.modify_user.first_name')"
      type="text" class="mb-4" />
    <TextInput id="telephone" v-model="phone" data-cy="phone" :label="$t('views.modals.modify_user.phone')" type="tel"
      class="mb-4" />
    <TextInput id="mail" v-model="email" data-cy="email" :label="$t('views.modals.modify_user.email')" type="email"
      class="mb-4" />

    <select v-model="role" class="mb-4 p-2 text-gray-700 rounded border border-gray-300 bg-white">
      <option value="User" selected>
        {{ $t("views.modals.modify_user.commune_account") }}
      </option>
      <option value="Admin">
        {{ $t("views.modals.modify_user.admin_account") }}
      </option>
    </select>

    <TownSelection :starting-towns="params.towns_data" />

    <ModifyButtons @modify="modify" @close="close" @delete="deleteAccount" />
  </div>
</template>

<style scoped>
select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
  outline: none;
}

select::-ms-expand {
  display: none;
}
</style>
